import { axiosInstance } from "./apiConfig"

export const apiStores = async (countryId, language = 'en') => {
    try {
        const response = await axiosInstance.get(`/geography/country/${countryId}/stores?language=${language}`);
        return response.data;
    } catch (error) {
        console.log(error);
    }
}


// WEBPACK FOOTER //
// ./src/api/stores.js